import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {BooleanLocale} from 'yup/lib/locale';
import {getCouponDetails} from '../api/coupon.api';
import type {RootState} from './store';

//import axios from 'axios';

export type couponData = {
  customerCouponId: string;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: string;
};

export interface couponResponse {
  coupons: couponData[] | '';
}

interface couponState {
  couponDetail: boolean;
  couponStateApiData: couponResponse | '';
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: couponState = {
  couponDetail: false,
  couponStateApiData: '',
  loading: false,
  error: '',
};
interface couponRequest {
  accessToken: string;
}
export const getAllCustomerCoupon = createAsyncThunk(
  'customer/getALlCustomerCOupon',
  async (parameters: couponRequest, thunkApi) => {
    return getCouponDetails(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const getCouponSlice = createSlice({
  name: 'getcoupondata',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(getAllCustomerCoupon.pending, state => {
      state.loading = true;
    });
    builder.addCase(getAllCustomerCoupon.fulfilled, (state, action) => {
      state.loading = false;
      state.couponDetail = true;
      state.couponStateApiData = action.payload;
    });
    builder.addCase(getAllCustomerCoupon.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetState} = getCouponSlice.actions;

export const CouponResp = (state: RootState): couponResponse | '' =>
  state.getCouponReducer.couponStateApiData;

export const errorCouponData = (state: RootState): string =>
  state.getCouponReducer.error;
export const loadingcouponData = (state: RootState): boolean =>
  state.getCouponReducer.loading;
export const couponData = (state: RootState): boolean =>
  state.getCouponReducer.couponDetail;

export default getCouponSlice.reducer;
